export const en = {
  portfolio: {
    tools: 'Filters & bulk actions',
    search: 'Search domains',
    expiry: 'Paid-through date',
    status: 'Status',
    all: 'All',
    on: 'Enabled',
    off: 'Disabled',
    expiry_all: 'Any date',
    expiry_expired: 'Expired',
    expiry_30: 'Next 30 days',
    expiry_90: 'Next 90 days',
    expiryHint: 'Dates include paid renewal credits. Expiry windows exclude domains that have already expired.',
    count: '{{count}} of {{total}} domains',
    reset: 'Reset filters',
    exportFiltered: 'Export filtered CSV',
    exportSelected: 'Export selected CSV',
    selected: '{{count}} selected',
    selectFiltered: 'Select all filtered',
    clear: 'Clear selection',
    select: 'Select',
    selectDomain: 'Select {{domain}}',
    selectionHint: 'Select up to {{limit}} domains per action, across pages. Changing filters clears the selection.',
    renew: 'Add renewals to cart',
    enable: 'Enable auto-renew',
    disable: 'Disable auto-renew',
    review: 'Review selected domains',
    renewHint: 'Add one renewal year per eligible domain to your cart. Review final prices and pay at checkout; this action does not charge you.',
    enableHint: 'Future renewal charges will follow your existing billing setup. This does not pay for a renewal now.',
    disableHint: 'You will need to renew these domains manually to keep them. Existing paid renewals and pending orders are unchanged.',
    priceAtCheckout: 'Price shown in cart',
    confirm: 'Confirm for these domains',
    results: 'Action results',
    running: 'Processing domains…',
    finished: 'Processing complete. Review the results below.',
    retry: 'Retry failed domains',
    checkout: 'Review cart',
    added: 'Added to cart',
    updated: 'Auto-renew updated',
    failed: 'Request failed. Please retry.',
    inactive: 'Not managed here; skipped',
    paid: 'Renewal already paid; skipped',
    pending: 'Renewal awaiting payment; skipped',
    unchanged: 'Already set; skipped',
    inCart: 'Already in cart; skipped',
    result_success: 'Success',
    result_failed: 'Failed',
    result_skipped: 'Skipped',
    deleted: 'Deleted',
    transferred: 'Transferred away',
    unknown: 'Unknown',
    previous: 'Previous',
    next: 'Next',
    page: 'Page {{page}} of {{pages}}',
    sort: 'Sort by',
    sort_name: 'Domain name',
    sort_expiry: 'Earliest expiry',
    sort_latest: 'Latest expiry',
  },
  common: {
    search: 'Search',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    loading: 'Loading...',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    status: 'Status',
    type: 'Type',
    value: 'Value',
    valueOptional: 'Value (Optional)',
    address: 'Address',
    city: 'City',
    state: 'State',
    country: 'Country',
    countryOrRegion: 'Country or region',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    code: 'Code',
    comment: 'Comment',
    settings: 'Settings',
    inUse: 'In use',
    inCart: 'In cart',
    domain: 'Domain',
    zipCode: 'Zip Code',
    yes: 'Yes',
    no: 'No',
    apply: 'Apply',
    verify: 'Verify',
    individual: 'Individual',
    company: 'Company',
    error: 'Error',
    default: 'Default',
    total: 'Total',
    items: 'Items',
    coupon: 'Coupon',
    remove: 'Remove',
    disable: 'Disable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    processing: 'Processing...',
    saveChanges: 'Save changes',
    openMenu: 'Open menu',
    paid: 'Paid',
    free: 'Free',
    subtotal: 'Subtotal',
    discount: 'Discount',
    amountDue: 'Amount Due',
    product: 'Product',
    quantity: 'Quantity',
    totalCost: 'Total Cost',
    actions: 'Actions',
    pay: 'Pay',
    host: 'Host',
    destination: 'Destination',
    hostname: 'Hostname',
    created: 'Created',
    notFoundDescription: 'The page you are looking for still needs to be programmed.',
    goToHome: 'Go to Home',
    notAuthenticated: 'Not Authenticated',
    toggleTheme: 'Toggle theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    allSystemsNormal: 'All systems normal',
    systemNotNormal: 'System not normal',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    rowsPerPage: 'Rows per page',
    selectSection: 'Select a section',
    noResults: 'No results.',
    searchCountry: 'Search country...',
    noCountryFound: 'No country found.',
    searchState: 'Search state...',
    selectCountryFirst: 'Select a country first',
    price: 'Price',
    faq: 'Frequently Asked Questions',
    perMonth: '/ month',
    perYear: '/ year',
    overview: 'Overview',
    beta: 'Beta',
    expired: 'Expired',
    expiringSoon: 'Expiring soon',
  },
  nav: {
    domains: 'Domains',
    registration: 'Registration',
    transfer: 'Transfer',
    tldPrices: 'TLD Prices',
    hosting: 'Hosting',
    websiteHosting: 'Website hosting',
    services: 'Services',
    docs: 'Docs',
    whoisLookup: 'Whois Lookup',
    whois: 'Whois',
    toggleMenu: 'Toggle menu',
    legal: 'Legal',
    termsOfService: 'Terms of Service',
    domainRegistrationAgreement: 'Domain Registration Agreement',
    websiteHostingAgreement: 'Website Hosting Agreement',
    dataProcessingAgreement: 'Data Processing Agreement',
    privacyPolicy: 'Privacy Policy',
    registrationDescription: 'Buy a new domain from YourWebTech.',
    transferDescription: 'Transfer your domain to YourWebTech.',
    tldPricesDescription: 'Check the prices of TLDs.',
    docsDescription: 'Read product documentation and help guides.',
  },
  auth: {
    login: 'Login',
    signIn: 'Sign in',
    signUp: 'Sign up',
    createAccount: 'Create account',
    createAnAccount: 'Create an account',
    enterEmailToCreate: 'Enter your email below to create your account',
    continueWithGoogle: 'Continue with Google',
    continueWithGitHub: 'Continue with GitHub',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    resetPassword: 'Reset password',
    emailAddress: 'Email address',
    orYouCanAlso: 'Or you can also',
    forgotPassword: 'Forgot your password?',
    forgotPasswordTitle: 'Forgot password',
    forgotPasswordDescription: "Enter your email and we'll send you a link to choose a new password.",
    invalidCredentials: 'Invalid credentials',
    signInUnavailable: "We couldn't sign you in right now. Please try again in a moment.",
    accountCreated: "Account created. We've sent a confirmation link to {{email}}.",
    loggedOut: 'Logged out successfully',
    enterEmailToLogin: 'Enter your email below to login to your account',
    twoFactorAuth: 'Two-Factor Authentication',
    twoFactorDescription: 'Enter the 6-digit code from your authenticator app to continue.',
    authenticationCode: 'Authentication code',
    twoFactorTitle: 'Two-Factor Authentication (TOTP)',
    twoFactorProtect: 'Protect your account by requiring a one-time code from an authenticator app when you sign in.',
    twoFactorEnabled: "You'll be asked for a code from your authenticator app when signing in.",
    twoFactorEnableHint: 'Enable TOTP to generate a secret for your authenticator app (e.g. Google Authenticator, 1Password, Authy).',
    twoFactorScanQr: 'Scan this QR code in your authenticator app',
    twoFactorSecretKey: 'Secret key (enter manually if needed)',
    twoFactorVerificationCode: 'Verification code from your authenticator app',
    twoFactorSixDigitCode: '6-digit code',
    enable2fa: 'Enable 2FA',
    disable2fa: 'Disable 2FA',
    verifyAndEnable: 'Verify & Enable',
    disable2faTitle: 'Disable two-factor authentication?',
    disable2faDescription: "You'll no longer be asked for a verification code when signing in. This reduces your account security.",
    // Auth store toasts
    mfaSessionExpired: 'MFA session expired. Please sign in again.',
    noMfaFactor: 'No MFA factor available.',
    mfaSignInError: 'Error completing 2FA sign in.',
    mustBeSignedIn2fa: 'You must be signed in to enable 2FA.',
    failedStart2fa: 'Failed to start 2FA enrollment: ',
    totpSecretNotFound: 'TOTP secret not found. Please start enrollment again.',
    twoFactorEnabledToast: 'Two-factor authentication enabled.',
    failedEnable2fa: 'Failed to enable 2FA: ',
    mustBeSignedInDisable2fa: 'You must be signed in to disable 2FA.',
    noTotpEnabled: 'No TOTP factor is currently enabled.',
    twoFactorDisabled: 'Two-factor authentication disabled.',
    failedDisable2fa: 'Failed to disable 2FA: ',
    errorSigningUp: "We couldn't create your account. Please try again.",
    exitImpersonation: 'Exit Impersonation',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    passwordRule: {
      minLength: 'At least 8 characters',
      uppercase: 'One uppercase letter',
      lowercase: 'One lowercase letter',
      number: 'One number',
    },
    invalidEmail: 'Please enter a valid email address',
    passwordRequired: 'Please enter your password',
    passwordRequirementsNotMet: 'The password does not meet all requirements yet',
    tooManyAttempts: 'Too many attempts. Please wait a few minutes or reset your password.',
    wrongEmailOrPassword: 'The email or password is incorrect.',
    noAccountYet: 'New here?',
    createAccountWithEmail: 'Create an account with {{email}}',
    emailAlreadyRegistered: 'There is already an account with this email.',
    signInInstead: 'Sign in instead',
    errorSendingResetLink: "We couldn't send the email. Please try again in a moment.",
    sendResetLink: 'Send reset link',
    checkYourInbox: 'Check your inbox',
    resetLinkSent: 'If there is an account for {{email}}, we have sent it a link to choose a new password.',
    resetLinkHelp: 'The link is valid for 1 hour. Nothing there? Check your spam folder or make sure the address is the one you signed up with.',
    useDifferentEmail: 'Use a different email',
    backToSignIn: 'Back to sign in',
    emailConfirmed: 'Email confirmed',
    emailConfirmedDescription: 'Thank you. We will use this address for your invoices and domain notices.',
    goToAccount: 'Go to your account',
    chooseNewPassword: 'Choose a new password',
    chooseNewPasswordFor: 'For {{email}}',
    newPassword: 'New password',
    saveAndSignIn: 'Save and sign in',
    linkInvalid: 'This link is no longer valid',
    verifyLinkInvalidDescription: 'It may have expired or already been used. If your email is not confirmed yet, you can send a new link from your account.',
    resetLinkInvalidDescription: 'Reset links work once and for 1 hour. Request a new one to choose your password.',
    requestNewLink: 'Request a new link',
    confirmEmailNotice: 'Please confirm your email address {{email}} with the link we sent you, so our invoices and domain notices reach you.',
    verificationEmailResent: 'We have sent a new link to {{email}}.',
    resendVerificationEmail: 'Send link again',
    errorSendingVerificationEmail: "We couldn't send the email. Please try again later.",
  },
  domain: {
    batch: {
      single: 'Single domain',
      title: 'Batch transfer',
      description: 'Upload or paste up to {{count}} .ch/.li domains and their transfer codes.',
      nameservers: 'Your existing nameservers stay in place. If your old provider also hosts your DNS, check that this service will continue after the transfer.',
      upload: 'Upload CSV',
      paste: 'Paste domains and transfer codes',
      format: 'Two columns: domain, auth_code. Commas, semicolons and tabs are supported; the header is optional. Maximum 64 KB. Use xn-- notation for internationalised names.',
      preview: 'Preview domains',
      review: 'Review {{count}} domains. Correct or remove any invalid rows, then check transfer eligibility.',
      pricing: 'Price per domain',
      transferPrice: 'Transfer:',
      renewalPrice: 'Renewal / year:',
      checkoutPrice: 'Price confirmed in checkout',
      check: 'Check domains ({{count}})',
      add: 'Add ready domains ({{count}})',
      startOver: 'Import another list',
      cartNotice: 'Only ready domains are added. Review the final prices in checkout before confirming the transfer. Removing a preview row does not remove a domain already in your cart.',
      checkout: 'Continue to cart',
      working: 'Processing domains. Please keep this page open.',
      remove: 'Remove',
      removeRow: 'Remove row {{count}}',
      domainRow: 'Domain in row {{count}}',
      codeRow: 'Transfer code in row {{count}}',
      empty: 'Enter at least one domain and transfer code.',
      tooLarge: 'The input exceeds 64 KB. Split it into smaller files.',
      tooMany: 'A batch can contain at most {{count}} domains. Split your list.',
      malformed: 'The file contains malformed CSV quotes. Check the quoted fields and try again.',
      columns: 'Each row must have exactly two columns: domain and auth_code.',
      readFailed: 'The file could not be read. Try again or paste its contents.',
      invalidDomain: 'Enter a valid .ch or .li domain, without a URL or subdomain.',
      missingCode: 'Enter a transfer code.',
      invalidCode: 'The transfer code contains a line break, control character, or more than 1,024 characters.',
      duplicate: 'This domain appears more than once. Remove the duplicate row.',
      inCart: 'Already in your cart.',
      unchecked: 'Not checked yet',
      checking: 'Checking…',
      ready: 'Ready to add',
      unavailable: 'Not transferable. Check the code and the status at your current registrar.',
      checkFailed: 'The check failed. Try checking this domain again.',
      adding: 'Adding to cart…',
      added: 'Added to cart',
      addFailed: 'Could not add to cart. Try adding this row again.',
    },
    domain: 'Domain',
    domainName: 'Domain Name',
    creationDate: 'Creation Date',
    expirationDate: 'Expiration Date',
    autoRenewal: 'Auto Renewal',
    autoRenew: 'Auto Renew',
    registrar: 'Registrar',
    nameservers: 'Nameservers',
    nameserversAndDns: 'Nameservers & DNS Records',
    nameserversTitle: 'Nameservers',
    nameserversDescription: 'By default, we use ywt nameservers for your domain. You can change them to your own nameservers. If so, the DNS records will be managed by your own nameservers.',
    nameserversChanged: 'Successfully changed nameserver',
    urlForwarding: 'URL Forwarding',
    rootHint: 'Use @ for root.',
    addToCart: 'Add to cart',
    tooLong: 'Domain too long!',
    tooShort: 'Domain too short!',
    port: 'Port',
    priority: 'Priority',
    target: 'Target',
    ttl: 'TTL',
    weight: 'Weight',
    manageDomain: 'Manage your domain',
    whoisPrivacy: 'Whois Privacy',
    whoisPrivacyEnabled: 'Whois Privacy is enabled by default. Your contact information is not publicly visible.',
    dnssec: 'DNSSEC',
    dnssecFull: 'Domain Name System Security (DNSSEC)',
    dnssecUpdated: 'DNSSEC updated',
    dnssecRecordAdded: 'DNSSEC record added',
    dnssecRecordRemoved: 'DNSSEC record removed',
    acmeKeysTitle: 'Certificate automation (ACME)',
    acmeKeysDescription:
      "Keys for certbot, acme.sh or lego, so they can renew Let's Encrypt or ZeroSSL certificates for this domain, wildcards included, with the DNS-01 challenge. A key can only add and remove TXT records at _acme-challenge names of this domain.",
    acmeKeysEmpty: 'No keys yet.',
    acmeKeyCreate: 'Create key',
    acmeKeyCreateHint: 'The key can only add and remove TXT records at _acme-challenge names of this domain. Its secret is shown once, right after you create it.',
    acmeKeyLabel: 'Label',
    acmeKeyLabelPlaceholder: 'For example: web server (optional)',
    acmeKeyUnnamed: 'No label',
    acmeKeyName: 'Key name',
    acmeKeyCreated: 'Created',
    acmeKeyRevoke: 'Revoke',
    acmeKeyRevokeTitle: 'Revoke this key?',
    acmeKeyRevokeConfirm: 'Certificate tools that use it can no longer update DNS: their next renewal fails until they get a new key.',
    acmeKeyLimit: 'A domain can have up to {{count}} keys. Revoke one to create another.',
    acmeKeyDocs: 'Setup guide',
    acmeKeyCreatedTitle: 'Key created',
    acmeKeySecretOnce: 'Copy the secret now: it is shown only this once. If you lose it, revoke the key and create a new one.',
    acmeKeyServer: 'Server',
    acmeKeyAlgorithm: 'Algorithm',
    acmeKeySecret: 'Secret',
    acmeKeySaveFile: 'Save this as {{path}}, readable only by root:',
    acmeKeyThenRun: 'Then run:',
    acmeKeyRun: 'Run:',
    acmeKeyDone: 'Done',
    acmeKeyCopy: 'Copy',
    acmeKeyCopied: 'Copied',
    acmeKeyCopyFailed: 'Could not copy. Select the text and copy it by hand.',
    acmeKeyCnameConflict: '_acme-challenge is a CNAME (to {{target}}), so these keys cannot write challenge records there. Delete that CNAME in the DNS records above to use them for this domain.',
    dnssecYwtHint: "You're using YWT Nameservers. You can easily enable or disable DNSSEC in one click.",
    dnssecAdvanced: 'Advanced DNSSEC Management',
    dnssecAdvancedHint: "Manage your domain DS (DNSSEC) records here. You know what you're doing!",
    dnssecNoRecords: 'No DNSSEC records.',
    dnssecAddRecord: 'Add DNSSEC Record',
    dnssecProvideDs: 'Provide DS record values. Key data is optional.',
    dnssecKeyTag: 'Key tag',
    dnssecAlgorithm: 'Algorithm',
    dnssecDigestType: 'Digest type',
    dnssecDigest: 'Digest',
    dnssecHexDigest: 'Hex digest (max 96 chars)',
    dnssecIncludeKeyData: 'Include key data',
    dnssecOptional: '[optional]',
    dnssecFlags: 'Flags',
    dnssecProtocol: 'Protocol',
    dnssecKeyAlgorithm: 'Key algorithm',
    dnssecPublicKey: 'Public key',
    dnssecBase64Key: 'Base64 key',
    dnssecFixedProtocol: 'Fixed: 3',
    dnssecKeyDataRequired: 'Required when key data is included',
    dnssecFillRequired: 'Please fill keyTag, algorithm, digestType and digest',
    dnssecKeyTagRange: 'keyTag must be between 0 and 65535',
    dnssecDigestMax: 'digest must be at most 96 characters',
    dnssecKeyDataFieldsRequired: 'flags, protocol, key algorithm and public key are required when including key data',
    dnssecKeyTagLabel: 'Key tag:',
    dnssecAlgLabel: 'Alg:',
    dnssecDigestTypeLabel: 'Digest type:',
    dnssecDigestLabel: 'Digest:',
    dnssecSelect: 'Select',
    dnssecAllowedAlgorithms: 'Allowed: 8, 10, 13, 14, 15, 16',
    dnssecAllowedDigestTypes: 'Allowed: 2 or 4',
    searchTitle: 'Search for a .ch/.li domain',
    searchDescription: 'Registrating a domain has never been this simple, clean and fast.',
    searchPlaceholder: 'Find your dream domain here...',
    searchInfoTitle: 'About .ch and .li domains',
    searchInfoIntro:
      'YourWebTech is a Swiss, SWITCH-accredited registrar. Search any .ch or .li name above to check availability and register it in minutes — DNSSEC, full DNS control and WHOIS privacy are included with every domain.',
    faqRegEligibilityQ: 'Who can register a .ch or .li domain?',
    faqRegEligibilityA: '.ch and .li domains are open to anyone worldwide — there is no residency or local-presence requirement. You only need valid contact details.',
    faqRegSpeedQ: 'How long does registration take?',
    faqRegSpeedA: 'Registrations go through the Swiss SWITCH registry and usually complete within a few minutes. Your domain and DNS are ready to manage as soon as it finishes.',
    faqRegDnssecQ: 'Are DNSSEC and DNS management included?',
    faqRegDnssecA: 'Yes. Every domain includes free DNSSEC, our Swiss name servers, and a simple editor for A, AAAA, CNAME, MX, TXT and other records — at no extra cost.',
    faqRegTransferInQ: 'Can I transfer in a domain I already own?',
    faqRegTransferInA: 'Yes — you can transfer existing .ch and .li domains to YourWebTech for free. Start from the transfer page with your domain auth code.',
    transferTitle: 'Transfer a .ch/.li domain',
    transferDescription: 'Enough waiting for a week? Unlike other registrars, we offer <bold>instant</bold> domain transfers.',
    transferNotAvailable: 'Domain is not available for transfer',
    perYear: '/ year',
    renewsAt: 'renews at',
    registration: 'Registration',
    renewal: 'Renewal',
    renewalDescription: 'Manage auto renewal and create a renewal order if needed.',
    autoRenewalLabel: 'Auto renewal',
    autoRenewalHint: 'Receive a reminder email with payment link 30 days before expiry.',
    autoRenewalEnabled: 'Auto renewal enabled',
    autoRenewalDisabled: 'Auto renewal disabled',
    autoRenewalInfo: "If enabled, you will receive a auto recharge or an email reminder 30 days before expiry. Otherwise, it's at risk of expiry and you have to renew manually.",
    renewNow: 'Renew now',
    renewNowHint: 'Create a renewal order instantly and pay right away.',
    renewalAddedToCart: 'Renewal added to cart',
    renewalOrderCreated: 'Renewal order ready',
    renewalFeePaidTill: 'Renewal fee paid till {{date}}',
    goToCart: 'Go to cart',
    noDomains: 'No domains yet',
    noDomainsDescription: "You haven't registered any domains yet.",
    copyNameservers: 'Copy Nameservers',
    ywtNs: 'YourWebTech NS',
    ywtNsTooltip: 'YWT is using the following DNS servers for this domain: ',
    expires: 'Expires:',
    dnsRecords: 'DNS Records',
    dnsRecordsDescription: 'DNS records point to services your domain uses, like forwarding your domain or setting up an email service.',
    dnsOwnNameservers: 'You are using your own nameservers.',
    dnsOwnNameserversHint: 'You can manage your DNS records directly at your own nameservers provider.',
    dnsFailedToAdd: 'Failed to add DNS record',
    dnsEditRecord: 'Edit {{type}} Record',
    dnsEditRecordHint: "Make changes to the record here. Click save when you're done.",
    dnsDeleteRecord: 'Delete Record',
    dnsDeleteConfirm: 'You are about to remove the following record, are you sure you want to continue?',
    dnsAuto: 'Auto',
    dnsAutoTooltip: 'DNS records are managed automatically',
    removeDomain: 'Remove Domain',
    removeDomainDescription: 'Remove the domain from your account.',
    removeDomainConfirm: 'Are you sure you want to remove the domain <strong>{{domain}}</strong> from your account?',
    removeDomainIrreversible: 'This action is irreversible and the domain will be deleted from your account.',
    removeDomainSuccess: 'Domain removed from your account.',
    yesRemoveIt: 'Yes, remove it',
    dangerZone: 'Danger Zone',
    dangerZoneDescription: 'The features you rarely need.',
    transferOut: 'Transfer Out',
    transferOutHint: "You just happened to click the wrong button, right? Do you know that you don't have to transfer your domain in order to host it somewhere else?",
    transferOutConfirm: 'But if you are sure you want to transfer out <strong>{{domain}}</strong>, we will make it easy and generate a new auth code and email it to you.',
    transferOutSuccess: 'We have emailed you the auth code.',
    transferOutNotAllowed: 'Transfer-out not allowed.',
    yesMadeUpMind: "Yes, I've made up my mind",
    transferProhibitedInfo: 'The domain is currently not transferable. If you just transferred the domain to us, this is normal.',
    transferredAwayBadge: 'Transferred away',
    transferredAwayTitle: 'This domain was transferred to another registrar.',
    transferredAwayDescription: 'It is no longer managed by YourWebTech and is shown here for reference only. You can remove it from your account at any time.',
    deletedTitle: 'This domain was deleted',
    deletedRestorable: 'It expired and was deleted at the registry, so its website, email and other services no longer work. You can restore it until {{date}}.',
    restoreIncludesYear: 'The price includes the next year.',
    restoreKeepsDns: 'Its DNS records are kept. Websites and URL forwarding that used it need to be added again after the restore.',
    restoreAfterDeadline: 'After {{date}}, anyone can register it.',
    restoreDomainFor: 'Restore for {{price}}',
    deletedNoLongerRestorable: 'It expired and was deleted at the registry, and can no longer be restored. Once the registry releases it, anyone can register it again.',
    deletedRestoreBySupport: 'It expired and was deleted at the registry. To restore it, please contact our support.',
    restorableUntilBadge: 'Deleted · restore until {{date}}',
    deletedBadge: 'Deleted',
    oneYear: '1 year',
    oneYearTooltip: "The registry only allows to register maximum one year. But don't worry, we'll set up auto renew for each domain until you cancel it.",
    // URL Forwarding
    urlForwardingTitle: 'URL Forwarding',
    urlForwardingDescription: 'Redirect your domain (and optional subdomains) to another website.',
    howForwardingWorks: 'How forwarding works',
    howForwardingWorksDescription:
      'Create one or more forwarding rules below. Leave hostname blank to forward the root domain. Enable wildcard forwarding to also forward subhosts. The forwarding takes effect normally in a few minutes.',
    editRule: 'Edit Rule',
    addNew: 'Add New',
    hostnameLabel: 'Hostname',
    blankForRoot: '(blank for root)',
    hostnameExample: 'Example: "www" forwards {{hostname}}',
    forwardTrafficTo: 'Forward traffic to',
    invalidUrlHint: 'Invalid input. Must start with http or https',
    wildcardForwarding: 'Wildcard forwarding',
    wildcardForwardingHint: 'Also forward subhosts of this hostname',
    wildcardForwardingInfo: 'When enabled, this rule also forwards subhosts. Example: hostname "abc" + wildcard forwards both "abc.{{host}}" and "*.abc.{{host}}" (e.g. def.abc.example.com").',
    includePathLabel: 'Include path',
    includePathHint: 'Append path + query to destination',
    includePathInfo: 'When enabled, the requested path + query (e.g. "/docs?x=1") will be appended to the destination URL.',
    advancedLabel: 'Advanced',
    advancedHint: 'Status code (default 307)',
    advancedInfo: 'Choose the redirect status code. Default is 307 (temporary) to preserve method and body.',
    redirectType: 'Redirect type',
    selectStatusCode: 'Select status code',
    updateRule: 'Update Rule',
    addRule: 'Add Rule',
    currentForwards: 'Current Forwards',
    noForwards: 'No forwards configured.',
    includePath: 'Include path',
    noPath: 'No path',
    checking: 'Checking...',
    dnsOk: 'OK',
    dnsOkTooltip: 'DNS is correctly pointing to our servers',
    dnsMissing: 'Missing',
    dnsConfigRequired: 'DNS Configuration Required',
    dnsAutoAdded: 'These records should be added automatically. Click "Re-check" if they are not appearing.',
    dnsAddRecords: 'Add the following DNS records through your DNS provider:',
    recheckDns: 'Re-check DNS',
    sslActive: 'Active',
    sslActiveTooltip: 'SSL certificate is active',
    sslWaitingForDns: 'Waiting for DNS',
    sslWaitingForDnsTooltip: 'HTTPS starts automatically once DNS points to YourWebTech',
    sslIssuing: 'Issuing',
    sslIssuingTooltip: 'The SSL certificate is being issued, usually within a minute',
    editRuleTooltip: 'Edit rule',
    deleteRuleTooltip: 'Delete rule',
    permanentRedirectWarning: 'Permanent Redirect Warning',
    permanentRedirectBody: "You're about to create a <strong>permanent redirect ({{code}})</strong>.",
    permanentRedirectCacheWarning: 'Browsers and search engines cache permanent redirects aggressively. If you make a mistake, users may continue being redirected even after you remove the rule.',
    permanentRedirectSuggestion: "Use a temporary redirect (302 or 307) if you're testing or may need to change this later.",
    permanentRedirectConfirm: 'I understand, create permanent redirect',
    forwardAdded: 'Forward added',
    forwardUpdated: 'Forward updated',
    forwardingRemoved: 'Forwarding removed',
    forwardRemoved: 'Forward removed',
    ruleEnabled: 'Rule enabled',
    ruleDisabled: 'Rule disabled',
    transferDomainPlaceholder: 'The domain to be transferred',
    authCodePlaceholder: 'The authorization code',
    // Nameservers
    useYwtNameservers: 'Use YWT Nameservers',
    useYwtNameserversDescription: 'Use our default nameservers to manage your DNS records automatically.',
    defaultNameservers: 'Default Nameservers:',
    customNameservers: 'Custom Nameservers:',
    noneConfigured: 'None configured',
    nameserver1: 'Nameserver 1',
    nameserver2: 'Nameserver 2',
    nameserver3Optional: 'Nameserver 3 (Optional)',
    nameserver4Optional: 'Nameserver 4 (Optional)',
    dnsCommentPlaceholder: 'A comment explaining what this DNS record is for.',
    dnsCommentDescription: 'This is only for your reference and will not impact your DNS record.',
    expirationRenewalTooltip: "The domain's current expiration date is {{registryDate}} in registry. But it will be renewed automatically till {{renewalDate}}.",
    // Domain pricing page
    pricingTitle: 'Domain prices',
    pricingSubtitle: 'Renewing costs the same as registering, and transfers are free. No cheap first year that gets expensive later.',
    pricingHeadline: '{{price}} a year. Every year.',
    compareTitle: 'What a .ch domain costs over {{years}} years',
    compareSubtitle: 'Many registrars discount the first year and make it back on every renewal.',
    compareRegistrar: 'Registrar',
    compareFirstYear: 'First year',
    compareRenewal: 'Each renewal',
    compareTotal: '{{years}} years',
    compareMoreThanUs: 'More than YWT',
    compareFootnote: "Prices including Swiss VAT, as published on each registrar's website on {{date}}. Totals = first year + one renewal for every further year.",
    domainTld: 'Domain TLD',
    vatNote: '*Prices include 8.1% Swiss VAT for customers in Switzerland.',
    findYourDomain: 'Find your domain',
    whatsIncludedDomain: "What's included with every domain",
    ywtDnsServers: 'YWT DNS Servers',
    dnssecSupportFeature: 'DNSSEC Support',
    urlForwardingFeature: 'URL Forwarding',
    easyDnsManagement: 'Easy DNS Management',
    greatUx: 'Great UX',
    freeTransfers: 'Free Transfers',
    emailSupport: 'Email Support',
    noHiddenFees: 'No Hidden Fees',
    faqTrustQ: 'Should I trust you?',
    faqTrustA: 'We are an accredited registrar recognized by the Swiss official registry - <switch>SWITCH</switch>. This should prove that we are serious about our business and our customers.',
    faqVatQ: 'How is VAT handled?',
    faqVatA:
      'The displayed price is the same for everyone. Swiss customers have 8.1% VAT included in the price (shown on invoices). Customers outside Switzerland pay the same amount but no Swiss VAT applies.',
    faqHiddenFeesQ: 'Are there any hidden fees?',
    faqHiddenFeesA: 'No. Our pricing plan is transparent. What you see is what you pay. We do not charge extra setup fee, service fee or any other fees.',
    faqRenewalPriceQ: 'Is the renewal price the same as the registration price?',
    faqRenewalPriceA:
      'Yes, unlike many other registrars who lure you in with ultra cheap first year registration fee and then triple the renewal price, we charge the same price for renewal as for registration.',
    faqTransfersQ: "Don't you charge anything for domain transfers?",
    faqTransfersA: "Right, we don't charge you for domain transfers. We welcome all domain holders to join us and enjoy our services.",
    faqPaymentMethodsQ: 'What payment methods do you accept?',
    faqPaymentMethodsA: 'We accept all major credit cards (Visa, Mastercard, American Express). More payment methods could be evaluated and added in the future.',
    faqPriceChangesQ: 'Can prices change?',
    faqPriceChangesA:
      'Many factors can influence the price of a domain. For instance, <switch>SWITCH</switch> can change wholesale costs, infrastructure costs can fluctuate, etc. But we try to keep the price as accessible as possible.',
    faqRefundsQ: 'Can I request a refund?',
    faqRefundsA:
      "If a domain is successfully registered or renewed, you cannot request a refund because it's already been processed with <switch>SWITCH</switch>. If your domain registration, transfer or renewal did not complete, please contact support and we'll help you.",
    faqMoreThanOneYearQ: 'Can I register a domain for more than one year?',
    faqMoreThanOneYearA: "It's technically not possible to register .ch/.li domains for more than one year. The registry <switch>SWITCH</switch> only allows to register maximum one year.",
  },
  checkout: {
    paymentDetail: 'Payment Detail',
    enterBillingAddress: 'Enter billing address',
    editBillingAddress: 'Edit billing address',
    payNow: 'Pay now',
    payOrder: 'Pay order',
    noPay: "I don't need to pay",
    paymentSecureForm: 'Use the secure form below to complete your payment.',
    paymentFormUnavailable: 'Payment form unavailable',
    paymentFormUnavailableDescription: 'Stripe could not load. Check content blockers or your network connection, then refresh this page.',
    paymentMethodNotAvailable: 'Kindly let us know if your preferred payment method is not available.',
    savePaymentMethod: 'Save this payment method for future purchases',
    termsAccept: '*By placing this order, you accept our',
    termsOfService: 'Terms of Service',
    privacyNotice: "and acknowledge that you've read and understood our",
    privacyPolicy: 'Privacy Policy',
    unexpectedError: 'An unexpected error occurred.',
    paymentProcessingTitle: 'Confirming your payment…',
    paymentProcessingDescription: 'Your order has been received and we are confirming the payment. This can take a few seconds — you do not need to pay again.',
    viewOrderStatus: 'View order status',
    paymentFailedTitle: 'Your payment did not go through',
    paymentFailedDescription: 'The payment was declined or not completed, so nothing was charged. You can try again with the same or another payment method.',
    retryPayment: 'Try paying again',
    orderReview: 'Order Review',
    orderDescription: 'Here is a list of your order items. (order ID: {{orderId}})',
    finishOrder: 'Finish your order',
    reviewAndPay: 'Review your order and proceed to pay.',
    emptyOrder: 'This order is empty. Please delete this order and search for domains again.',
    domainsUnavailable: 'Some of the domains in this order are not available anymore. This order is invalid. Please delete this order and search for domains again.',
    paymentMethods: 'Payment methods',
    newPaymentMethod: 'New payment method',
    couponCode: 'Coupon code',
    vatExempt: '(Not subject to Swiss VAT)',
    vatIncluded: '(8.1% VAT incl.)',
    websiteHosting: 'Website Hosting',
    notApplicable: 'Not applicable',
    yourCart: 'Your Cart',
    cartDescription: 'Start your web tech from here.',
    cartEmpty: 'Your cart is empty.',
    addMoreToCart: 'Add more to cart',
    continueToCheckout: 'Continue to checkout',
    goToCheckout: 'Go to checkout',
    unpaidOrders: 'But you have unpaid orders.',
    unpaidRenewalOrders: 'Unpaid renewal orders:',
    viewAmountsDue: 'View amounts due',
    amountsDue: 'Amounts due',
    amountsDueDescription: 'Review unpaid renewal orders and combine them into one invoice.',
    amountsDueEmpty: 'There are no unpaid renewal orders right now.',
    payAllInOneInvoice: 'Pay all in one invoice',
    renewalOrderDomainCount: '{{count}} domain renewal items',
    viewOrders: 'View orders',
    order: 'Order',
    thankYou: 'Thank you!',
    paymentReceived: 'Your payment has been received.',
    freeOrderPlaced: 'You have placed a free order.',
    orderProcessing: "We'll process your order and send you a confirmation e-mail within a few minutes.",
    domainItems: 'Domain Items:',
    amountPaid: 'Amount Paid:',
    amountRemaining: 'Amount Remaining:',
    dateAndTime: 'Date & Time:',
    viewMyOrder: 'View my order {{id}}',
    goToMyWebsite: 'Go to my website',
    goToMyWebsites: 'Go to my websites',
    orderFrom: 'Order {{id}} from {{date}}',
    totalDue: 'Total Due',
    invoiceNumber: 'Invoice Number',
    domainType: 'Domain {{type}}',
    deleteOrder: 'Delete Order',
    deleteOrderConfirm: 'You are about to delete the order {{id}}, are you sure you want to continue?',
    orderDeletedSuccess: 'Order deleted successfully',
    oneYear: '1 Year',
    oneMonth: '1 Month',
    upgradeToPlan: 'Upgrade to {{plan}} Plan',
    plan: '{{plan}} Plan',
    days: '{{count}} days',
    daysUntilDate: '({{count}} days until {{date}})',
    autoRenewMonthly: 'Unless you cancel, your subscription will renew automatically every month.',
    autoRenewYearly: 'Unless you cancel, your subscription will renew automatically every year.',
    summary: 'Summary',
    cartSummary: 'Your cart summary.',
    cart: 'Cart',
    registrantAddress: 'Registrant address',
    billingAddress: 'Billing address',
    createOrder: 'Create order',
    cartEmptyWithOrders: 'Your cart is empty. Do you have unfinished <link>orders</link>?',
    priceFreeFun: 'Nothing is better than free!',
    priceCoffee: 'About the price of a coffee',
    priceBeer: 'About the price of a beer',
    priceLunch: 'About the price of a basic lunch',
    priceLunchMenu: 'About the price of a lunch menu',
  },
  contact: {
    maintenance: {
      title: 'Registrant contacts',
      description: 'Manage the people or companies registered as domain holders.',
      edit: 'Edit contact details',
      defaultContact: 'Default for purchases',
      saved: 'Contact details updated.',
      sharedNotice:
        'This updates the shared contact at the registry for every domain that uses it, including technical contact references. Linked billing details follow the default contact; existing invoices stay unchanged. For a different holder, use Change holder in the domain settings.',
      linkedDomains: 'Domains using this holder:',
      sameHolder: 'I confirm these are updated details for the same person or company.',
      newContactNotice: 'Creating a contact does not change any existing domain holder or your default contact.',
      holderTitle: 'Domain holder',
      holderDescription: 'Choose who holds this domain. This keeps the domain in your account and leaves DNS, the technical contact, and billing unchanged.',
      currentHolder: 'Current holder',
      currentUnavailable: 'Current holder details are unavailable. Please contact support.',
      newHolder: 'New holder',
      chooseHolder: 'Choose a contact',
      noOtherContacts: 'No other contacts yet. Add a registrant address to choose a new holder.',
      changeHolder: 'Change holder',
      holderNotice: 'You are changing the registered holder of {{domain}} to the contact shown above.',
      holderConfirmation: 'I am authorised by the current holder to make this change and confirm that the new holder agrees.',
      holderSaved: 'Domain holder changed.',
    },
    createRegistrant: 'Create registrant',
    registrantType: 'Registrant type',
    billingType: 'Billing type',
    companyContact: 'Company',
    companyName: 'Company Name',
    vatId: 'VAT ID',
    registrantContact: 'Registrant Contact',
    registrantContactRequired: 'You have not created a registrant contact yet. This is required by registry.',
    registrantContactInfo: 'Your contact information is required by the registry.',
    continueToCheckout: 'Continue to checkout',
    sameAsRegistrant: 'Same as the registrant address',
    legalNameDescription: 'Your legal name that will be stored by the registry.',
    companyNameDescription: 'Company name if the billing is a company.',
    companyNameRegistrantDescription: 'Company name if the registrant is a company.',
    vatDescription: 'VAT number for business customers (optional).',
    contactEmailDescription: 'Your contact email.',
    enterPhoneNumber: 'Enter a phone number',
    realNamePlaceholder: 'Real name',
    companyPlaceholder: 'Company',
    vatIdPlaceholder: 'CHE-123.456.789',
    streetAndNumber: 'Street and number',
    additionalAddress: 'Additional address information',
    state: 'State',
    countryOrRegion: 'Country or region',
    vatIdLabel: 'VAT ID:',
    addNewRegistrant: 'Add new registrant address',
  },
  account: {
    myAccount: 'My Account',
    account: 'Account',
    orders: 'Orders',
    domains: 'Domains',
    websiteHosting: 'Website hosting',
    manageAccountSettings: 'Manage your account settings.',
    logOut: 'Log out',
    admin: 'Admin',
    paymentMethods: 'Payment methods',
    paymentMethodsDescription: 'Manage your saved payment methods.',
    noPaymentMethods: 'No saved payment methods.',
    setAsDefault: 'Set as default',
    defaultPaymentMethodSet: 'Default payment method set successfully',
    paymentMethodDeleted: 'Payment method deleted successfully',
    expires: 'Expires {{month}}/{{year}}',
    default: 'Default',
    // Avatar
    avatar: 'Avatar',
    avatarDescription: 'Fancy adding a profile image? You can do it here.',
    removeAvatar: 'Remove Avatar',
    uploadAvatar: 'Upload Avatar',
    avatarUpdated: 'Avatar updated.',
    avatarUpdateFailed: 'Failed to update avatar.',
    avatarRemoved: 'Avatar removed.',
    selectValidImage: 'Please select a valid image file.',
    avatarUploadHint: 'Upload an image up to 128x128 pixels. Larger images will be resized.',
    // Order overview
    orderTitle: 'Order',
    orderFrom: 'from {{date}}',
    openMenu: 'Open menu',
    viewOrder: 'View Order',
    pay: 'Pay',
    paymentStatus: 'Payment status:',
    invoiceStatusPaid: 'Paid',
    invoiceStatusDraft: 'Draft',
    invoiceStatusOpen: 'Open',
    invoiceStatusVoid: 'Void',
    invoiceStatusUncollectible: 'Uncollectible',
    discount: 'Discount:',
    total: 'Total:',
    notInitiated: '{{type}} not initiated',
    waitingForRegistry: 'Waiting to communicate with registry',
    manageOrders: 'View and manage your orders',
    noOrdersYet: 'No orders yet',
    noOrdersDescription: "You haven't made any orders.",
    // Profile
    manageYourDomains: 'Manage your domains',
    validEmailAddress: 'Please enter a valid email address.',
    emailDescription: 'Your email address is used to login and receive notifications and can not be changed.',
    displayName: 'Display Name',
    displayNameDescription: 'Please enter your full name, or a display name you are comfortable with.',
    displayNameHint: 'Please use 32 characters at maximum.',
    displayNamePlaceholder: 'How can we call you?',
    recoveryEmail: 'Recovery Email',
    recoveryEmailDescription: "We don't send any emails to this address. We identify you by this email address if you lost your main email account.",
    recoveryEmailHint: 'Please use a valid email address.',
    // Delete account
    deleteAccount: 'Delete account',
    deleteAccountDescription: 'Permanently delete your account and the data linked to it. This cannot be undone.',
    deleteAccountBlockedDomains: 'You still have domains registered with us. Transfer them to another registrar or delete them first:',
    deleteAccountBlockedOrder: 'One of your orders is still being processed. Please try again once it has completed.',
    deleteAccountBlockedAdmin: 'Admin accounts cannot be deleted here.',
    deleteAccountBlockedImpersonation: 'An account cannot be deleted while it is being impersonated.',
    deleteAccountDialogTitle: 'Delete your account permanently?',
    deleteAccountDialogDescription: 'This cannot be undone. We will permanently delete:',
    deleteAccountItemProfile: 'Your profile, login, contacts and saved payment methods',
    deleteAccountItemOrders: 'Your cart and unpaid orders',
    deleteAccountItemDns: 'DNS zones and URL forwarding of domains you removed or transferred away',
    deleteAccountItemSites: 'Your websites ({{count}}) with all files, deployments and custom domains',
    deleteAccountItemSubscription: 'Your hosting subscription ends immediately, without a refund',
    deleteAccountRetention: 'Invoices for completed payments ({{count}}) are kept for ten years, as Swiss law requires, and deleted afterwards.',
    deleteAccountConfirmLabel: 'Type your email address to confirm',
    deleteAccountReauth: 'Please sign out, sign in again and retry, so we can confirm it is you.',
    deleteAccountSuccess: 'Your account has been deleted.',
  },
  hosting: {
    createNewWebsite: 'Create New Website',
    createStaticSite: 'Create a static site',
    createStaticSiteDescription: 'Provide a name and subdomain for your site.',
    siteName: 'Site name',
    subdomain: 'Subdomain',
    siteNamePlaceholder: 'Landing page, portfolio, blog, etc.',
    subdomainPlaceholder: 'my_site',
    subdomainHint: '3-32 chars: a-z, 0-9, _',
    creating: 'Creating...',
    createSite: 'Create Site',
    siteCreated: 'Site created',
    nameRequired: 'Name is required',
    nameMaxLength: 'Name must be at most 64 characters',
    subdomainMinLength: 'Subdomain must be at least 3 characters',
    subdomainMaxLength: 'Subdomain must be at most 32 characters',
    subdomainCharsOnly: 'Only a-z, 0-9 and _ are allowed',
    noWebsitesYet: 'No Websites Yet',
    noWebsitesDescription: "You haven't created any websites yet. Get started by creating your first website.",
    deleteSite: 'Delete Site',
    deleteSiteTitle: 'Delete "{{name}}"?',
    deleteSiteDescription: 'This will permanently remove the site, its custom domains, and all deployed files. This action cannot be undone.',
    deleting: 'Deleting...',
    siteDeleted: 'Site deleted',
    renameSiteDescription: "Only the name changes. Your site's address stays the same.",
    siteRenamed: 'Site renamed',
    siteIconTitle: 'Icon',
    siteIconHelp: 'Shown for this website in your account; visitors do not see it. Click the icon to choose an image (at most 500 KB).',
    redirectsNotForParked: 'A coming-soon page has no redirects.',
    deleteSiteSectionTitle: 'Delete this website',
    publishingYourSite: 'Publishing Your Site',
    savingFiles: 'Saving your files...',
    creatingNewVersion: 'Creating new version...',
    generatingPreview: 'Generating preview...',
    makingItLive: 'Making it live...',
    mayTakeFewSeconds: 'This may take a few seconds...',
    siteIsLive: 'Your Site is Live!',
    redirectingToOverview: 'Redirecting to your site overview...',
    uploadZipArchive: 'Upload Zip Archive',
    uploadZipDescription: 'Upload your static site as a .zip file. Its files are unpacked into your draft, where you can preview and edit them.',
    chooseZipFile: 'Please choose a .zip file.',
    onlyZipSupported: 'Only .zip files are supported.',
    uploading: 'Uploading...',
    uploadingWait: 'Please wait while your file is uploaded',
    extractingFiles: 'Extracting files...',
    extractingToWorkspace: 'Unpacking your zip file into your draft',
    uploadComplete: 'Upload Complete!',
    redirectingToEditor: 'Opening your draft...',
    uploadFailed: 'Upload Failed',
    tryAgain: 'Try Again',
    replaceExistingFiles: 'Replace Existing Files?',
    existingFilesCount: 'Your draft has <strong>{{count}}</strong> existing file(s).',
    replaceAllWarning: 'Uploading this zip will <strong>replace all existing files</strong>.',
    replaceAllFiles: 'Replace All Files',
    uploadAndExtract: 'Upload & Extract',
    afterExtraction: 'After extraction, you can preview and edit your files before publishing.',
    filesExtracted: 'Files extracted successfully!',
    active: 'Active',
    updated: 'Updated {{date}}',
    selectImageFile: 'Please select an image file',
    imageTooLarge: 'Image must be less than 500KB',
    faviconUpdated: 'Favicon updated',
    faviconUpdateFailed: 'Failed to update favicon',
    clickToChangeFavicon: 'Click to change favicon',
    // Editor file tree
    files: 'Files',
    newFile: 'New File',
    newFolder: 'New Folder',
    uploadFiles: 'Upload Files',
    rename: 'Rename',
    moveTo: 'Move to...',
    noFilesYet: 'No files yet',
    moveFile: 'Move File',
    moveFileDescription: 'Select a destination folder for',
    current: '(current)',
    rootFolder: '/ (root)',
    // Editor code panel
    noFileSelected: 'No file selected',
    selectFileToEdit: 'Select a file to start editing',
    modified: 'Modified',
    download: 'Download',
    imagePreview: 'Image Preview',
    videoPreview: 'Video Preview',
    audioPreview: 'Audio Preview',
    pdfPreview: 'PDF Preview',
    binaryFile: 'Binary File',
    cannotPreview: 'This file type cannot be previewed here.',
    downloadFile: 'Download File',
    robotsTxtHint:
      'Preview URLs always return <code class="bg-blue-500/20 px-1 rounded">Disallow: /</code> to prevent search engines from indexing preview content. Your robots.txt will work correctly when published.',
    // Editor empty state
    workspaceEmpty: 'Nothing here yet',
    chooseHowToStart: "Choose how you'd like to get started building your site",
    startFresh: 'Start Fresh',
    startFreshDescription: 'Create an empty index.html',
    createPage: 'Create a page',
    createPageDescription: 'Fill in a form. No code.',
    createPageFailed: 'Could not create the page',
    advancedOptions: 'Advanced',
    uploadFilesDescription: 'Upload files and folders',
    uploadZip: 'Upload Zip',
    uploadZipShortDescription: 'Extract a .zip archive',
    uploadWebsite: 'Upload your website',
    uploadWebsiteDescription: 'A zip of your site, or the one file your AI assistant gave you.',
    chooseUploadFile: 'Choose a .zip or .html file.',
    onlyZipOrHtmlSupported: 'Only .zip and .html files are supported.',
    htmlTooLarge: 'This file is too large. The limit is {{limit}}.',
    htmlUploaded: 'Your page was saved as index.html.',
    uploadWebsiteHint: 'A zip is unpacked into your site. A single .html file becomes your home page (index.html).',
    htmlReplacesIndex: 'This file replaces your current index.html. Your other files are kept.',
    uploadNoFileYet: 'No file yet? See how to build one with ChatGPT or Claude.',
    buildWithAssistant: 'Build it with your AI assistant',
    buildWithAssistantDescription: 'Use ChatGPT or Claude, then upload the one file it gives you.',
    aiCardTitle: 'Build it with ChatGPT or Claude',
    aiCardDescription: 'Your AI assistant asks you a few questions and builds your page. You upload one file.',
    aiCardButton: 'Show me how',
    chooseTemplate: 'Choose a Template',
    chooseTemplateDescription: 'Start with a beautiful design',
    loadFromVersion: 'Load from Version',
    loadFromVersionDescription: 'Copy from existing version',
    beta: 'Beta',
    latest: 'Latest',
    // Template gallery
    templateGalleryDescription: 'Start with a beautifully designed template and customize it to your needs',
    all: 'All',
    applying: 'Applying...',
    useThisTemplate: 'Use This Template',
    preview: 'Preview',
    back: 'Back',
    needMoreTemplates: 'Need more templates?',
    useTemplate: 'Use Template',
    templateApplied: 'Template "{{name}}" applied successfully!',
    failedToApplyTemplate: 'Failed to apply template',
    // Deployments
    history: 'History',
    noVersionsYet: 'No versions yet. Each time you publish, a version is saved here.',
    publishedFromEditor: 'Published from your draft',
    fileUpload: 'File Upload',
    zipUpload: 'Zip Upload',
    live: 'Live',
    updatedTime: 'Updated:',
    // Deployment page actions
    version: 'Version',
    failedToRestore: 'Could not restore this version.',
    versionNowLive: 'Version is now live!',
    failedToEditCopy: 'Could not copy this version for editing.',
    editCopyReady: 'You are now editing a copy of this version.',
    versionDeleted: 'Version deleted',
    failedToDeleteVersion: 'Failed to delete version.',
    previewVersion: 'Preview Version',
    editCopy: 'Edit a copy of this version',
    replaceDraftTitle: 'Replace your draft?',
    replaceDraftDescription: 'This replaces all files in your draft with this version. Changes you have not published will be lost.',
    deleteVersion: 'Delete Version',
    deleteVersionTitle: 'Delete this version?',
    deleteVersionDescription: 'This will permanently remove this version and its stored files. This action cannot be undone.',
    restoring: 'Restoring...',
    restoreVersion: 'Restore this version',
    downloadVersion: 'Download this version (zip)',
    // Share draft and download (Edit toolbar)
    downloadFiles: 'Download files',
    shareDraft: 'Share draft',
    shareDraftTitle: 'Share your draft',
    shareDraftDescription: 'Anyone with the link can see your draft until the link expires. It goes on the internet under your domain only when you publish.',
    shareDraftDuration: 'The link works for',
    shareDraft1d: '1 day',
    shareDraft7d: '7 days',
    shareDraft30d: '30 days',
    shareDraftCreate: 'Create link',
    shareDraftLink: 'Link to your draft',
    shareDraftExpires: 'Expires on {{date}}',
    shareDraftCopyManually: 'The link is selected: copy it with Ctrl+C or ⌘C.',
    copyLink: 'Copy',
    copied: 'Copied',
    stopSharing: 'Stop sharing',
    stopSharingConfirm: 'Every link you have created so far stops working.',
    stopSharingDone: 'Your draft links no longer work.',
    // Deployment overview
    previewUrl: 'Preview URL',
    domains: 'Domains',
    createdVia: 'Created Via',
    editor: 'Edited online',
    git: 'Git',
    madeLive: 'Made Live',
    duration: 'Duration',
    size: 'Size',
    buildFailed: 'Build Failed',
    versionPreview: 'Version Preview',
    openPreview: 'Open Preview',
    currentlyLive: 'Currently Live',
    connectedDomains: 'Connected Domains',
    // Deployment status
    statusReady: 'Ready',
    statusFailed: 'Failed',
    statusBuilding: 'Building',
    statusUploaded: 'Uploaded',
    statusPending: 'Pending',
    // Empty deployment
    versionNotFound: 'Version Not Found',
    versionNotFoundDescription: 'This version could not be loaded. It may have been deleted or there was an error.',
    // Performance panel
    runAnalysis: 'Run Analysis',
    analyzing: 'Analyzing...',
    screenshot: 'Screenshot',
    performance: 'Performance',
    // Files upload
    uploadFilesTitle: 'Upload Files',
    uploadFilesDialogDescription: 'Upload files directly to your draft. You can preview and edit them before publishing.',
    selectAtLeastOneFile: 'Please select at least one file.',
    uploadedFilesSuccess: 'Uploaded {{count}} file(s) successfully!',
    uploadFailedRetry: 'Upload failed. Please try again.',
    replaceExistingFilesQuestion: 'Replace Existing Files?',
    existingFileCount: 'Your draft has <strong>{{count}}</strong> existing file(s).',
    uploadWillReplaceAll: 'Uploading will <strong>replace all existing files</strong>.',
    clearingWorkspace: 'Clearing your draft...',
    removingExistingFiles: 'Removing existing files',
    uploadingProgress: 'Uploading... ({{current}}/{{total}})',
    pleaseWaitUploading: 'Please wait while your files are uploaded',
    uploadLimitsExceeded: 'Upload Limits Exceeded',
    uploadLimitsDescription: 'The selected files exceed the limits for individual file uploads.',
    tooManyFiles: 'Too many files:',
    youSelected: 'You selected {{count}} files, but the limit is {{max}} files.',
    filesExceedSize: '{{count}} file(s) exceed the {{limit}} size limit:',
    andMore: '...and {{count}} more',
    useZipUpload: 'Use ZIP Upload instead',
    useZipUploadDescription:
      'For uploading many files or large files, compress your project into a <strong>.zip</strong> file and use the <strong>Upload Zip</strong> option. This is faster and supports larger projects.',
    goBack: 'Go Back',
    selectFiles: 'Select Files',
    selectFolder: 'Select Folder',
    filesSelected: '{{count}} file(s) selected',
    clearAll: 'Clear All',
    useZipForLarger: '<strong>Use ZIP upload</strong> for larger projects.',
    selectFilesToUpload: 'Select files or a folder to upload to your draft',
    fileLimitsInfo: 'Limit: {{maxFiles}} files, {{maxSize}} per file. For larger uploads, use ZIP.',
    uploadCount: 'Upload {{count}} File(s)',
    upload: 'Upload',
    // Static site domains
    domainAdded: 'Domain added',
    domainAddedWithRedirect: 'www.{{domain}} added. {{domain}} will redirect to www.{{domain}} automatically.',
    upgradeToAddDomains: 'Upgrade to Add Custom Domains',
    upgradeToAddDomainsWithCount: 'Upgrade to Add Domains ({{used}}/{{limit}})',
    addDomain: 'Add Domain',
    addDomainWithCount: 'Add Domain ({{used}}/{{limit}})',
    addADomain: 'Add a domain',
    enterDomainToMap: 'Enter the domain to map to this site.',
    domainSource: 'Domain source',
    buyADomain: 'Buy a domain',
    myDomains: 'My Domains',
    thirdPartyDomains: 'Third-party domains',
    myDomainsDnsHint: 'We will automatically handle DNS and SSL certificate for you.',
    thirdPartyDnsHint: 'After you add the domain, we show you the DNS records to create at your DNS provider.',
    subdomainOptional: 'Subdomain (optional)',
    selectADomain: 'Select a domain',
    noDomainsWithUs: "You don't have any domains with us yet.",
    saving: 'Saving\u2026',
    addDomainButton: 'Add domain',
    // Delete domain
    removeDomainTitle: 'Remove "{{hostname}}"?',
    removeDomainMapping: 'This will remove the domain mapping from this site. You can add it again later.',
    domainRemoved: 'Domain removed',
    removing: 'Removing\u2026',
    // Analytics
    analytics: 'Analytics',
    days7: '7 days',
    days30: '30 days',
    days90: '90 days',
    visitors: 'Visitors',
    pageViews: 'Page Views',
    bandwidth: 'Bandwidth',
    visitorsAndPageViews: 'Visitors & Page Views',
    topPages: 'Top Pages',
    views: 'Views',
    topReferrers: 'Top Referrers',
    countries: 'Countries',
    devices: 'Devices',
    browsers: 'Browsers',
    noData: 'No data',
    noPageData: 'No page data',
    noReferrerData: 'No referrer data',
    noCountryData: 'No country data',
    vsPrevious: 'vs previous',
    noAnalyticsYet: 'No analytics data yet',
    noAnalyticsDescription: 'Analytics data will appear here once your site starts receiving traffic.',
    // Static sites page
    websiteFallback: 'Website',
    hostFastSecure: 'Host fast, secure websites without servers.',
    upgradeToCreateMore: 'Upgrade to Create More',
    // Editor page
    takingLonger: 'Taking longer than expected',
    uploadRunningFor: 'Upload has been running for {{time}}.',
    extractionRunningFor: 'Extraction has been running for {{time}}.',
    cancelAndRetry: 'You can cancel and try again with a smaller file.',
    cancelStartOver: 'Cancel & Start Over',
    pleaseWaitProcessing: 'Please wait while your files are being processed',
    elapsed: 'Elapsed: {{time}}',
    extractionFailed: 'Extraction Failed',
    errorProcessingFiles: 'An error occurred while processing your files.',
    troubleshootingTips: 'Troubleshooting tips:',
    tipZipNotCorrupted: 'Make sure the zip file is not corrupted',
    tipSmallerZip: 'Try with a smaller zip file (under 100MB)',
    tipNoSpecialChars: 'Avoid special characters in file/folder names',
    tipValidFiles: 'Ensure the zip contains valid static website files',
    unsavedChangesTitle: 'Discard unsaved changes?',
    unsavedChangesDiscard: 'Your changes to this file have not been saved and will be lost.',
    discardChanges: 'Discard changes',
    fileCountLabel: '{{count}} file(s)',
    fromVersion: 'From version #{{version}}',
    deleteFileConfirm: 'Delete "{{path}}"?',
    deleteFileDescription: 'It will be removed from your draft. Published versions are not affected.',
    tooManyFilesInline: 'Too many files ({{count}}/{{max}}).',
    filesExceedInline: '{{count}} file(s) exceed {{limit}}.',
    andMoreFiles: '...and {{count}} more files',
    failedToLoadFile: 'Failed to load file',
    failedToLoadPreview: 'Failed to load file preview',
    fileSaved: 'File saved',
    failedToSaveFile: 'Failed to save file',
    failedToCreateFile: 'Failed to create file',
    folderCreated: 'Folder created',
    failedToCreateFolder: 'Failed to create folder',
    fileDeleted: 'File deleted',
    failedToDeleteFile: 'Failed to delete file',
    fileRenamed: 'File renamed',
    failedToRenameFile: 'Failed to rename file',
    failedToCreateStarter: 'Failed to create starter file',
    workspaceInitialized: 'Draft copied from the version',
    failedToLoadDeployment: 'Failed to load from deployment',
    publishStoppedSaveFailed: 'Your changes could not be saved, so nothing was published. Please try again.',
    failedToPublish: 'Failed to publish',
    workspaceCleared: 'Draft cleared',
    failedToClearWorkspace: 'Failed to clear your draft',
    startOver: 'Start Over',
    startOverTitle: 'Start over from scratch?',
    startOverDescription: 'This will clear all files in your draft so you can start fresh. Your published versions will not be affected.',
    publish: 'Publish',
    publishing: 'Publishing...',
    publishYourWebsite: 'Publish your website',
    filesTooLarge: 'Files too large',
    uploadMaxFiles: 'You can upload up to {{max}} files at once.',
    useZipForBulk: 'Use ZIP Upload for bulk files',
    useZipForBulkDescription: 'For uploading many files or large files, use the Upload ZIP option instead. Go to the site overview and use "Upload ZIP" to upload your entire project at once.',
    goToOverview: 'Go to Overview',
    // Site overview page
    visitSite: 'Visit Site',
    draft: 'Draft',
    liveUrl: 'Live URL',
    noCustomDomain: 'No custom domain configured.',
    addOne: 'Add one',
    moreDomains: '+{{count}} more domain(s)',
    previewOnly: 'Preview Only',
    previewOnlyDescription: 'Only people with its preview link can see this site. Publish it to get a public address.',
    viewLive: 'View Live',
    getStarted: 'Get Started',
    getStartedDraftDescription: 'Build your page, then choose a plan to publish it.',
    getStartedDescription: 'Nothing is published yet. Build your page, then publish it.',
    editYourPage: 'Edit your page',
    sitePreview: 'Site preview',
    historyLink_one: 'History ({{count}} version)',
    historyLink_other: 'History ({{count}} versions)',
    visitorsLast30Days: 'Visitors, last 30 days',
    visitorsLast30DaysCount: 'Visitors, last 30 days: {{count}}',
    versionCount_one: '{{count}} version',
    versionCount_other: '{{count}} versions',
    visitorsLast30DaysValue: '{{count}} in the last 30 days',
    nextFinishTitle: 'Finish your page',
    nextFinishText: 'Your page is not on the internet yet. Finish it, then click Publish.',
    nextPublishTitle: 'Publish your page',
    nextPublishText: 'Your draft can be shared with its preview link. Choose a plan to put it on the internet.',
    nextConnectTitle: 'Connect your domain',
    nextConnectText: 'Your page is live at {{address}}. Connect your own domain so visitors find it under your name.',
    nextFinishConnectingTitle: 'Finish connecting {{hostname}}',
    nextFinishConnectingText: 'The domain is waiting for its DNS records. The Domains tab shows what to set.',
    showDnsRecords: 'Show DNS records',
    nextReplaceParkedTitle: 'Replace with a real page',
    nextReplaceParkedText: 'A real website needs a plan.',
    nextReplaceParkedPlanText: 'Turn your coming-soon page into a real page you edit with a form.',
    replaceParkedButton: 'Replace',
    replaceParkedDialogTitle: 'Replace with a real page?',
    replaceParkedDialogText: 'Your coming-soon page becomes a real page you edit with a form. It counts toward your plan and goes live at once.',
    replaceParkedConverting: 'Replacing...',
    seePlans: 'See plans',
    // Coming-soon page on a domain registered at YWT
    putPageOnDomainTitle: 'Put a page on {{domain}}',
    putPageOnDomainText: 'Show visitors a page while you build your website. Free for domains registered at YWT.',
    putPageOnDomainButton: 'Create page',
    putPageDialogTitle: 'A coming-soon page for {{domain}}',
    putPageDialogDescription: 'Visitors to {{domain}} see this page until your website is ready. You can change it at any time.',
    putItOnline: 'Put it online',
    puttingOnline: 'Putting it online...',
    parkedHeadline: 'Headline',
    parkedMessage: 'Message',
    parkedContactEmail: 'Contact email (optional)',
    parkedDefaultMessage: 'We are building something special.',
    parkedHeadlineRequired: 'Enter a headline.',
    parkedMessageRequired: 'Enter a message.',
    parkedTooLong: 'At most {{max}} characters.',
    parkedEmailInvalid: 'Enter a valid email address.',
    parkedEditTitle: 'Your coming-soon page',
    parkedEditDescription: 'Visitors to {{domain}} see this page. Saving puts your changes online.',
    parkedDomainsNote: 'This page is shown on {{domain}} and www.{{domain}}.',
    comingSoonBadge: 'Coming soon page',
    // Business page (a one-page website made from a form)
    businessEditTitle: 'Your page',
    businessEditDescription: 'Fill in the form; the preview shows your page. Save keeps your changes, Publish puts them on the internet.',
    businessName: 'Name',
    businessTagline: 'Tagline (optional)',
    businessAbout: 'About (optional)',
    businessServices: 'Services (optional)',
    businessService: 'Service {{n}}',
    businessRemoveService: 'Remove service {{n}}',
    businessAddService: 'Add a service',
    businessHours: 'Opening hours (optional)',
    businessPhone: 'Phone (optional)',
    businessEmail: 'Email (optional)',
    businessAddress: 'Address (optional)',
    businessTheme: 'Colours',
    businessThemeLight: 'Light',
    businessThemeDark: 'Dark',
    businessThemeWarm: 'Warm',
    businessThemeCool: 'Cool',
    businessNameRequired: 'Enter a name.',
    businessPhoneInvalid: 'Use only digits, spaces and + ( ) -.',
    businessPhoto: 'Photo (optional)',
    businessPhotoHint: 'JPEG, PNG or WebP, up to 2 MB. It is saved right away.',
    businessPhotoShown: 'Your photo is at the top of the page.',
    businessPhotoChoose: 'Choose a photo',
    businessPhotoReplace: 'Replace photo',
    businessPhotoRemove: 'Remove photo',
    businessPhotoWrongType: 'Choose a JPEG, PNG or WebP image.',
    businessPhotoTooLarge: 'The photo is larger than 2 MB.',
    businessPhotoFailed: 'Could not save the photo',
    businessPreviewTitle: 'Preview of your page',
    businessPreviewEmpty: 'The preview appears here.',
    businessPreviewUpdating: 'Updating...',
    businessSaved: 'Page saved',
    businessSaveFailed: 'Failed to save the page',
    unsavedPageDiscard: 'Your changes to this page have not been saved and will be lost.',
    businessPageBadge: 'Page',
    // Custom domains page
    primaryDomainUpdated: 'Primary domain updated',
    failedToSetPrimary: 'Failed to set primary domain',
    domainConnected: 'Connected',
    invalidConfiguration: 'Invalid Configuration',
    pendingDns: 'Pending DNS',
    customDomains: 'Custom Domains',
    customDomainsDescription: 'Connect your own domain to this website',
    notLiveYetWarning: 'This website is not live yet. The following domains will not take effect.',
    noCustomDomainsYet: 'No custom domains yet.',
    primary: 'PRIMARY',
    refreshStatus: 'Refresh status',
    setAsPrimary: 'Set as Primary',
    setAsPrimaryNotConnected: '(not connected yet)',
    setAsPrimaryNotForParked: '(not for a coming-soon page)',
    primaryLabel: '(Primary)',
    dnsConfigRequired: 'DNS Configuration Required',
    dnsConfigDescription: 'Add the following DNS record to your domain provider to verify ownership.',
    dnsPropagationNote: 'DNS changes usually takes about half an hour, but can take up to 48 hours to propagate. We check automatically every 30s.',
    // Hosting plans page
    plansTitle: 'Static Website Hosting',
    plansSubtitle: 'No complex setup. No hidden fees. Simple, fast, secure and reliable hosting.',
    salesClosedTitle: 'Static hosting is no longer available',
    salesClosedDescription: 'Static hosting is no longer offered to new customers. Existing subscriptions continue until their end date.',
    salesClosedLearnMore: 'About static hosting',
    siteLimitReached: 'Website limit reached',
    customDomainLimitReached: 'Custom domain limit reached',
    tierPlan: '{{tier}} Plan',
    alreadySubscribed: "You're already subscribed to Static Hosting.",
    manageYourPlan: 'Manage Your Plan',
    featureHttpsTitle: 'HTTPS included',
    featureHttpsDesc: 'No certificates to manage. Secure by default.',
    featureFastTitle: 'Fast loading',
    featureFastDesc: 'Static pages load quickly, with no server code to wait for.',
    featureDomainsTitle: 'Custom domains',
    featureDomainsDesc: 'Easy setup for your own domains.',
    featureSwissTitle: 'Swiss Datacenter',
    featureSwissDesc: 'Data stays in Switzerland infrastructure.',
    billingMonthly: 'Monthly',
    billingYearly: 'Yearly',
    savePercent: 'Save {{percent}}%',
    billedMonthly: 'billed monthly',
    billedYearlyFor: 'billed yearly for',
    noSubscriptionRequired: 'no subscription or payment required',
    freeTrialDesc: 'Try and build before you make the decision.',
    startForFree: 'Start for free',
    oneWebsite: '1 website',
    embeddedEditor: 'Embedded code editor',
    fileZipUpload: 'File/Zip upload',
    previewLinkFeature: 'Preview link you can share',
    publishNeedsPlanFeature: 'Publishing needs a plan',
    noCustomDomainFeature: 'No custom domain',
    publishOnStarter: 'Publish your site with a custom domain on Starter.',
    popularLabel: 'Popular',
    starterDesc: 'Everything you need to run a real website.',
    yourCurrentPlan: 'Your current plan',
    downgradeToStarter: 'Downgrade to Starter',
    getStarter: 'Get Starter',
    featuresFromFree: 'Features from free plan',
    oneCustomDomain: '1 custom domain',
    customDomainTooltip: 'Use your own domain (e.g. yourname.ch). Domain registration not included.',
    websiteAnalysis: 'Website analysis & monitoring',
    fastSecureDeliveryFeature: 'Fast, secure delivery with HTTPS',
    emailSupportFeature: 'Email support',
    fourteenDayGuarantee: '14-day money-back guarantee',
    perfectForPersonal: 'Perfect for personal sites & small businesses.',
    businessDesc: 'For multiple websites and higher usage.',
    upgradeToBusinessButton: 'Upgrade to Business',
    chooseBusiness: 'Choose Business',
    featuresFromStarter: 'Features from Starter plan',
    upToFiveWebsites: 'Up to 5 websites',
    upToTenDomains: 'Up to 10 custom domains',
    higherTraffic: 'Higher traffic',
    prioritySupport: 'Priority email support',
    thirtyDayGuarantee: '30-day money-back guarantee',
    needMoreWebsites: "Need more than 5 websites? Let's talk.",
    moneyBackTitle: 'Up to 30 days Money-back guarantee',
    moneyBackDesc: "Within the money-back guarantee period, if you're not happy with our service, we'll refund you. No questions asked.",
    whatsIncludedAll: "What's included in all plans",
    httpsIncludedFeature: 'HTTPS included',
    managedDns: 'Managed DNS',
    noServerMaintenance: 'No server maintenance',
    fairUseTraffic: 'Fair use traffic',
    noHiddenFeesFeature: 'No hidden fees',
    fairUseNote: "Fair use applies. We'll contact you before any limits are reached.",
    faqWhatIsStaticQ: 'What is static website hosting?',
    faqWhatIsStaticA:
      "Static hosting serves pre-built HTML, CSS, and JavaScript files directly to visitors. It's perfect for landing pages, portfolios, documentation, blogs built with tools like Hugo, Jekyll, or Next.js (static export), and single-page applications (React, Vue, etc.).",
    faqDynamicQ: 'Can I run dynamic content like PHP or databases?',
    faqDynamicA:
      "No. Static hosting only serves files \u2014 there's no server-side processing. If you need PHP, Node.js backends, or databases, you'll need a different hosting solution. However, you can use external APIs and serverless functions for dynamic features.",
    faqCustomDomainQ: 'How do I connect my own domain?',
    faqCustomDomainA:
      "After creating your website, go to the Domains tab and add your domain. We'll provide DNS records to configure. If your domain is registered with us, DNS is set up automatically. HTTPS certificates are issued automatically once DNS is configured.",
    faqDeployQ: 'How do I deploy my website?',
    faqDeployA: 'Edit your page right in your browser, upload files, or upload a ZIP archive, then click Publish. All of this is in your website dashboard.',
    faqHttpsQ: 'Is HTTPS/SSL included?',
    faqHttpsA: "Yes! All websites get free HTTPS certificates automatically. Once your domain's DNS is configured correctly, we issue and renew certificates for you \u2014 no manual steps required.",
    faqVatQ: 'How is VAT handled?',
    faqVatA:
      'The displayed price is the same for everyone. Swiss customers have 8.1% VAT included in the price (shown on invoices). Customers outside Switzerland pay the same amount but no Swiss VAT applies.',
    faqRefundQ: "What's the money-back guarantee?",
    faqRefundA: "If you're not satisfied within the guarantee period (14 days for Starter, 30 days for Business), contact us and we'll issue a full refund \u2014 no questions asked.",
    faqFreePlanQ: 'Can I use the free plan to build my website?',
    faqFreePlanA: 'Yes. On the free plan you can build your page and share it with a preview link. Publishing it on the internet under your domain needs a plan.',
    faqUpgradeQ: 'Can I upgrade my plan later?',
    faqUpgradeA: "Yes. You can upgrade from Starter to Business at any time. We'll prorate the difference for the remaining period of your subscription.",
    faqFairUsageQ: 'What is the fair usage policy?',
    faqFairUsageA:
      "We don't impose hard traffic limits, but expect normal website usage. If your site experiences unusual spikes (e.g., viral traffic or abuse), we'll reach out before taking any action. The vast majority of websites never come close to any limits.",
    faqDataLocationQ: 'Where is my website stored?',
    faqDataLocationA: 'Your website files are stored in infrastructure located in Zurich, Switzerland.',
    faqAnalyticsQ: 'Do you offer website analytics?',
    faqAnalyticsA:
      "Yes! We provide performance analytics that show your website's loading speed, Core Web Vitals, and optimization suggestions. And also Visitor analytics such as page views, visitors, devices, browsers, referrers, countries, etc.",
    faqSupportQ: 'How do I get support?',
    faqSupportA: 'Email us at <email>support@ywt.ch</email>. Business plan customers receive priority support with faster response times.',
    // Path redirects
    redirectsTitle: 'Path Redirects',
    redirectsDescription: 'Redirect a specific path of your site to another URL, on this site or anywhere else.',
    redirectsHowItWorksTitle: 'How path redirects work',
    redirectsHowItWorksBody:
      "Rules match a path exactly ('/blog' also matches '/blog/') and are applied before your site's files — a rule wins even if a file still exists at that path. Changes go live within about a minute.",
    redirectFromLabel: 'From path',
    redirectToLabel: 'Redirect to',
    redirectFromHint: "Must be a path starting with '/', without query or spaces",
    redirectToHint: "Enter an absolute URL (https://…) or a path on this site starting with '/'",
    addRedirect: 'Add Redirect',
    updateRedirect: 'Update Redirect',
    editRedirect: 'Edit Redirect',
    currentRedirects: 'Current Redirects',
    noRedirects: 'No redirects configured yet.',
    redirectPermanent: 'Permanent ({{code}})',
    redirectTemporary: 'Temporary ({{code}})',
    redirectAdded: 'Redirect added',
    redirectUpdated: 'Redirect updated',
    redirectRemoved: 'Redirect removed',
  },
  aiAssistant: {
    title: 'Build your website with your AI assistant',
    pitch: 'Use the ChatGPT or Claude you already have: it asks you questions, builds your page, and you upload one file. Trying it is free; you pay only when you want to go live.',
    step1Title: 'Copy this line and paste it into your assistant',
    oneLiner: 'Read {{url}} and help me build my website',
    step1Description: 'Your assistant reads our instructions from that page. Nothing to install, nothing to connect.',
    copy: 'Copy',
    copiedShort: 'Copied',
    copied: 'The line is on your clipboard. Paste it into your assistant.',
    copyFailed: 'Could not copy. Select the line and copy it by hand.',
    step2Title: 'Answer its questions and download the index.html it gives you',
    step2Description:
      'It asks what the website is for, your name, what you offer and how to reach you, then builds the page and shows it to you. Ask for changes until you like it, then download the file.',
    step3Title: 'Create a site at YWT and upload that file',
    step3Description:
      'Under Website hosting, create a site and choose "Build it with your AI assistant" on its Edit tab. You can preview it and share a draft link right away. To put it on your domain, publish it with the Starter plan.',
    goToHosting: 'Website hosting',
    seePlans: 'See the plans',
    tabsTitle: 'Where to paste it',
    chatgptOpen: 'Open ChatGPT (chatgpt.com or the desktop app) and start a new chat.',
    claudeOpen: 'Open Claude (claude.ai or the desktop app) and start a new chat.',
    pasteAndEnter: 'Paste the line and press Enter.',
    noBrowsingHint: 'If it says it cannot open the page, use "Copy the full prompt" below and paste that instead.',
    chatgptResult: 'The finished page comes back as a downloadable file. Save it as index.html.',
    claudeResult: 'The finished page appears as an artifact next to the chat. Use its download button and save it as index.html.',
    fullPromptTitle: 'Your assistant cannot open links?',
    fullPromptDescription: 'Copy the full starter prompt (in English) and paste it into the chat instead. It works the same way.',
    copyFullPrompt: 'Copy the full prompt',
    fullPromptCopied: 'The full prompt is on your clipboard. Paste it into your assistant.',
    fullPromptFailed: 'Could not fetch the prompt. We opened the docs page in a new tab; copy it from there.',
    openDocs: 'Read it on the docs site',
    faqPhotosQ: 'What about photos?',
    faqPhotosA: 'Your assistant cannot see your photos, so it leaves a placeholder where each one goes. After uploading your page, add the photos in the editor on the Edit tab.',
    faqChangesQ: 'How do I change something later?',
    faqChangesA: 'Download your index.html from the Edit tab, give it to your assistant and say what to change. Then upload the new file the same way.',
    faqCostQ: 'What does it cost?',
    faqCostA: 'Building the page and sharing a draft link is free, and so is your YWT account. Publishing it on the internet, on your own domain, needs the Starter plan.',
  },
  consent: {
    title: 'Analytics cookies',
    body: "Mind if we use analytics cookies? They help us see what works on this site and what doesn't.",
    accept: 'Sure',
    decline: 'No thanks',
    settings: 'Cookie settings',
  },
  footer: {
    productOf: 'is a product of Cupsar GmbH, \u00a9 Cuspar GmbH {{year}}',
    swissMadeSoftware: 'swiss made software',
  },
  admin: {
    domainSynced: 'Synced {{domain}}',
    domainsSynced: 'Synced {{count}} domain(s)',
    filterDomainsPlaceholder: 'Filter by domain or client email…',
    domainsShown: '{{shown}} / {{total}}',
    syncAllShown: 'Sync all shown ({{count}})',
    sync: 'Sync',
    domains: 'Domains',
    users: 'Users',
    subscriptions: 'Static Hosting Subscriptions',
    user: 'User',
    registrar: 'Registrar',
    expires: 'Expires',
    autoRenew: 'Auto renew',
    ywtDns: 'YWT DNS',
    deleted: 'Deleted',
    renewals: 'Renewals',
    urlForwarding: 'URL Forwarding',
    rules: '{{count}} rule(s)',
    staticSite: 'Static site',
    orders: 'Orders',
    websites: 'Websites',
    subscription: 'Subscription',
    none: 'None',
    impersonate: 'Impersonate',
    deleteUser: 'Delete account',
    deleteUserTitle: 'Delete the account of {{email}}?',
    deleteUserDescription:
      "This cannot be undone. The customer's profile, login, contacts, saved payment methods, cart, unpaid orders, websites ({{sites}}), DNS zones and URL forwarding are permanently deleted, and the customer is notified by email.",
    deleteUserSubscription: 'The active hosting subscription ends immediately, without a refund.',
    deleteUserRetention: 'Paid orders ({{count}}) are kept for ten years, as Swiss law requires.',
    deleteUserBlockedDomains: 'This customer still has domains registered with us. They must be transferred away or deleted first:',
    deleteUserBlockedOrder: "One of the customer's orders is still being processed. Try again once it has completed.",
    deleteUserBlockedAdmin: 'Admin accounts cannot be deleted.',
    deleteUserConfirmLabel: "Type the customer's email address to confirm",
    deleteUserSuccess: 'The account of {{email}} has been deleted.',
    owner: 'Owner',
    tier: 'Tier',
    interval: 'Interval',
    start: 'Start',
    cancelAtEnd: 'Cancel at end',
    eppAdmin: 'EPP Admin',
    general: 'General',
    auth: 'Auth',
    poll: 'Poll',
    statistics: 'Statistics',
    resources: 'Resources',
    domain: 'Domain',
    contact: 'Contact',
    host: 'Host',
  },
  subscription: {
    calculatingPlanChange: 'Calculating plan change...',
    upgradeTo: 'Upgrade to {{tier}}',
    upgradeImmediate: "You'll get immediate access to all {{tier}} features.",
    planUpgrade: '{{tier}} Plan upgrade',
    daysUntil: '{{days}} days until {{date}}',
    prorationExplanation: 'This is the price difference between {{currentTier}} and {{newTier}} for your remaining subscription period.',
    whatYouGet: "What you'll get:",
    upToWebsites: 'Up to {{count}} websites (currently {{current}})',
    upToCustomDomains: 'Up to {{count}} custom domains per site (currently {{current}})',
    redirectToPayment: 'You will be redirected to complete the payment.',
    createOrder: 'Create Order',
    downgradeTo: 'Downgrade to {{tier}}',
    downgradeAtEnd: 'Your plan will change at the end of your current billing period.',
    cannotDowngradeYet: 'Cannot downgrade yet:',
    planChangesOn: 'Plan changes on <strong>{{date}}</strong>',
    continueAccess: "You'll continue to have access to all {{tier}} features until then.",
    afterDowngrade: 'After downgrade:',
    maxWebsites: 'Max {{count}} website(s)',
    maxCustomDomains: 'Max {{count}} custom domain(s) per site',
    noRefund: 'No refund will be issued. You can cancel this scheduled change anytime before the end of your billing period.',
    scheduleDowngrade: 'Schedule Downgrade',
    upgradeComplete: 'Upgrade Complete!',
    downgradeScheduled: 'Downgrade Scheduled',
    nowHaveAccess: 'You now have access to all {{tier}} features. Enjoy!',
    planWillChange: 'Your plan will change to {{tier}} on {{date}}.',
    somethingWentWrong: 'Something went wrong',
    done: 'Done',
    downgradeToast: 'Downgrade to {{tier}} scheduled for {{date}}',
    changingTo: 'Changing to <strong>{{tier}}</strong> on {{date}}',
    scheduledChangeCancelled: 'Scheduled change cancelled',
    failedToCancelChange: 'Failed to cancel scheduled change',
    failedToCalculate: 'Failed to calculate plan change',
    failedToCreateOrder: 'Failed to create upgrade order',
    failedToSchedule: 'Failed to schedule downgrade',
    validationFailed: 'Validation failed',
    // FreePlanDialog
    freePlan: 'Free Plan',
    yourPlan: 'Your Plan',
    freeLabel: 'Free',
    freePlanDescription: 'The free plan lets you build and share a draft. Publishing puts it on the internet under your domain and needs a plan.',
    usage: 'Usage',
    websites: 'Websites',
    customDomains: 'Custom Domains',
    notAvailable: 'Not available',
    freePlanLimitations: 'Free Plan Limitations',
    publishNeedsPlan: 'Publishing needs a plan',
    noCustomDomain: 'No custom domain',
    upgradeToUnlock: 'Upgrade to unlock',
    permanentPublicUrl: 'Permanent public URL',
    customDomainSupport: 'Custom domain support',
    fastSecureDelivery: 'Fast, secure delivery with HTTPS',
    viewPlansAndPricing: 'View Plans & Pricing',
    // GoLiveDialog
    readyToGoLive: 'Ready to publish?',
    goLiveDescriptionWithName: 'The free plan lets you build and share "{{name}}" as a draft. Publishing puts it on the internet under your domain and needs a plan.',
    goLiveDescription: 'The free plan lets you build and share a draft. Publishing puts it on the internet under your domain and needs a plan.',
    whatsIncluded: "What's included:",
    draftModeNotice: 'Your site is a <strong>draft</strong>. Only people you send its preview link to can see it. Publishing makes it public.',
    // ExpiredPlanDialog
    renewPlan: 'Renew Plan',
    expired: 'Expired',
    ends: 'Ends',
    expiredDescription: 'Your subscription has expired. Renew to continue using your websites.',
    expiredNotice: 'Your {{tier}} plan ({{interval}}) expired on {{date}}.',
    expiredWarning: 'Your websites will be no longer publicly accessible soon. Renew your subscription to restore access.',
    plan: 'Plan',
    billing: 'Billing',
    monthly: 'Monthly',
    yearly: 'Yearly',
    expiredOn: 'Expired on',
    renewTierPlan: 'Renew {{tier}} Plan',
    renewCheckoutNotice: "You'll be taken to checkout to complete payment. Your subscription will be extended by {{period}} from today.",
    oneMonth: '1 month',
    // PlanManagementDialog
    managePlan: 'Manage Plan',
    managePlanDescription: 'View your subscription details and manage your plan.',
    cancelledNotice: "Your subscription will end on <strong>{{date}}</strong>. You won't be charged again.",
    billedInfo: 'Billed {{interval}} \u00b7 {{action}} on',
    planFeatures: 'Plan Features',
    websitesCount: '{{count}} website(s)',
    customDomainsCount: '{{count}} custom domain(s)',
    upgradeToBusiness: 'Upgrade to Business',
    downgradeToStarter: 'Downgrade to Starter',
    upgradeHint: 'Upgrade anytime. Pay only the price difference for remaining days.',
    downgradeHint: 'Downgrade will take effect at the end of your billing period.',
    cancelSubscription: 'Cancel Subscription',
    cancelSubscriptionTitle: 'Cancel your subscription?',
    cancelSubscriptionDescription:
      "Your subscription will remain active until <strong>{{date}}</strong>. After that, you'll lose access to your websites and custom domains. You can resume it here any time before then.",
    keepSubscription: 'Keep Subscription',
    yesCancel: 'Yes, Cancel',
    cancelSubscriptionSuccess: 'Subscription cancellation scheduled for {{date}}.',
    cancelSubscriptionFailed: 'Failed to cancel subscription',
    resumeSubscription: 'Resume Subscription',
    resumeSubscriptionTitle: 'Resume your subscription?',
    resumeSubscriptionDescription: 'Your {{tier}} plan will renew automatically on <strong>{{date}}</strong>, and your default payment method will be charged then.',
    resumeSubscriptionDismiss: 'Not now',
    resumeSubscriptionSuccess: 'Subscription resumed. It will renew on {{date}}.',
  },
  home: {
    swissAccreditedRegistrar: 'Swiss accredited registrar',
    heroTitle: 'your web tech',
    heroSubtitle: 'Register .ch/.li domains - fast, simple and clean.',
    heroSubtitlePrice: '.ch & .li domains for {{price}} a year, every year.',
    sameRenewalPrice: 'Same price every renewal',
    freeTransfers: 'Free transfers',
    comparePrices: 'See prices and compare',
  },
  whois: {
    title: 'Whois lookup',
    subtitle: 'Supports all TLDs. Minimal and fast.',
    placeholder: 'Enter a domain name to search...eg. example.com',
    check: 'Check',
    noData: 'No WHOIS data available for this domain.',
    disclaimer: 'Whois lookup is not real-time and may take up to 24 hours to update.',
    disclaimerTld: 'Depending on the TLD, the information may not be fully available.',
    summaryFor: 'Whois summary for',
    domain: 'Domain:',
    status: 'Status:',
    nameServers: 'Name servers:',
    created: 'Created:',
    expires: 'Expires:',
    updated: 'Updated:',
    whoisServer: 'WHOIS server:',
    dnssec: 'DNSSEC:',
    registrar: 'Registrar',
    registrant: 'Registrant',
    administrative: 'Administrative',
    technical: 'Technical',
    billing: 'Billing',
    registrarName: 'Name:',
    registrarWebsite: 'Website:',
    registrarEmail: 'Email:',
    registrarPhone: 'Phone:',
  },
} as const;
